import { useState, useEffect } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import MultiSelect from "../ReusableComponents/MultiSelect";
import CheckboxOrRadioGroup from "../ReusableComponents/CheckBoxOrRadioButton";

const InterpersonalContactsPopup = ({ data, data1, data2, data3 }) => {
  const [bindgenderRadioDD, setBindGenderRadioDD] = useState([]);
  const [bindtopics, setBindTopics] = useState([]);
  const [bindreferredtoDD, setBindreferredtoDD] = useState([]);
  const [bindreferelserviceDD, setBindreferelserviceDD] = useState([]);
  const issue = [
    { value: "1", label: "In-person" },
    { value: "2", label: "Virtual" },
  ];

  useEffect(() => {
    if (data3?.length) {
      DropDownValues(data3[0]);
      binddrpGenderdata(data3[2]);
      binddrpReferredtodata(data3[3]);
      binddrpReferredBydata(data3[4]);
    }
  }, [data3]);

  const DropDownValues = async (topicsValues = []) => {
    try {
      if (!Array.isArray(topicsValues) || topicsValues.length === 0) {
        setBindTopics([]);
        return;
      }

      const Drpbindtopics = topicsValues.map((m) => ({
        value: m.value,
        label: m.label,
      }));

      setBindTopics(Drpbindtopics);
    } catch (error) {
      console.error("Error setting BindTopics:", error);
    }
  };

  const binddrpGenderdata = async (genderValues = []) => {
    try {
      setBindGenderRadioDD(
        genderValues.map((m) => ({
          value: m.value,
          label: m.label,
        }))
      );
    } catch (error) {
      console.error("Error setting Gender data:", error);
    }
  };

  const binddrpReferredtodata = async (referralToValues = []) => {
    try {
      setBindreferredtoDD(
        referralToValues.map((m) => ({
          value: m.value,
          label: m.label,
        }))
      );
    } catch (error) {
      console.error("Error setting ReferredTo data:", error);
    }
  };

  const binddrpReferredBydata = async (referralByValues = []) => {
    try {
      setBindreferelserviceDD(
        referralByValues.map((m) => ({
          value: m.value,
          label: m.label,
        }))
      );
    } catch (error) {
      console.error("Error setting ReferredBy data:", error);
    }
  };

  useEffect(() => {
    const Clearvalues = () => {
      setTableData([]);
    };

    Clearvalues();

    try {
      // If data2 is already JSON string → parse it, else use directly
      const parsedData = typeof data2 === "string" ? JSON.parse(data2) : data2;

      if (Array.isArray(parsedData)) {
        const formattedDataArray = parsedData.map((data) => {
          const formattedDate1 = data.FallowUpDate
            ? data.FallowUpDate.split("T")[0]
            : "";

          return {
            participantNameEn: data.ParticipantName_en || "",
            age: data.MstAgeId || "",
            gender: data.MstGenderId || "",
            mobileNumber: data.MobileNumber || "",
            referralService: data.MstReferredById || "",
            referredTo: data.MstReferredToId || "",
            fallowUpDate: formattedDate1,
          };
        });

        setTableData(formattedDataArray);
      } else {
        console.warn("data2 is not an array:", parsedData);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }, [data2]);

  const [tableData, setTableData] = useState([
    {
      participantNameEn: "",
      age: "",
      gender: "",
      mobileNumber: "",
      referralService: "",
      referredTo: "",
      fallowUpDate: "",
    },
  ]);

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][columnName] = value;
      return newData;
    });
  };

  const updateTableData = (value, index, property) => {
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[index] = { ...updatedData[index], [property]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const headerData = [
    {
      title: "Name",
      key: "participantNameEn",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Age",
      key: "age",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Gender",
      key: "gender",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Mobile No.",
      key: "mobileNumber",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Referral Service",
      key: "referralService",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Referral To",
      key: "referredTo",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Follow-up",
      key: "fallowUpDate",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Action",
      key: "Action",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
  ];

  return (
    <div class="w-full">
      <div class=" flex flex-col w-full">
        <div class={mainTable.addShadowScreen}>
          <div class={mainTable.mainContentScreen}>
            <form class={mainTable.formPopupcontainer}>
              <div className={mainTable.grid3}>
                <InputText
                  inputType="date"
                  classStar="text-red-500"
                  title=" Date"
                  name="openingDate"
                  content={data.OpeningDate}
                  disabled={true}
                />
                <AutoDropDown
                  title="State"
                  classStar={"text-red-500"}
                  options={[]}
                  placeholder="Select"
                  name="state"
                  selectedOption={[data1[1]]}
                  disabled={true}
                  Class="custom-class"
                  tabIndex="1"
                />
                <AutoDropDown
                  title="Branch/Project"
                  classStar={"text-red-500"}
                  options={[]}
                  placeholder="Select"
                  name="state"
                  selectedOption={[data1[2]]}
                  disabled={true}
                  Class="custom-class"
                  tabIndex="1"
                />
                <AutoDropDown
                  title="S.D.P."
                  options={[]}
                  placeholder="Select"
                  classStar={"text-red-500"}
                  name="state"
                  selectedOption={[data1[3]]}
                  disabled={true}
                  Class="custom-class"
                  tabIndex="1"
                />
                <AutoDropDown
                  title="Area"
                  options={[]}
                  placeholder="Select"
                  name="state"
                  classStar={"text-red-500"}
                  selectedOption={[data1[4]]}
                  disabled={true}
                  Class="custom-class"
                  tabIndex="1"
                />
                <InputText
                  type="Place"
                  classStar="text-red-500"
                  title="Interpersonal Contact No. "
                  placeholder="MH/MUM/DHI/MAN/IPC/2023/00001 "
                  name="Place"
                  content={data.IECNo}
                  disabled={true}
                />
                <MultiSelect
                  classStar="text-red-500"
                  label="Topics"
                  filteredOptions={bindtopics}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    data1 && data1.length > 0 && data1[0] && data1[0].length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  classDiv="relative w-full inline-block"
                  name="Topics"
                  selectedOptions={data1 && data1[0] ? data1[0] : []}
                  disabled={true}
                />

                <CheckboxOrRadioGroup
                  classStar="text-red-500"
                  title="Channel"
                  type="radio"
                  setName="channel"
                  selectedOptions={[data1[9]]}
                  options={issue}
                  tabIndex={0}
                  disabled={true}
                />

                <AutoDropDown
                  title="Staff Name1"
                  classStar="text-red-500"
                  options={[]}
                  placeholder="Select"
                  name="staff"
                  Class="custom-class"
                  tabIndex="1"
                  selectedOption={[data1[5]]}
                  disabled={true}
                />
                <AutoDropDown
                  title="Staff Name2"
                  options={[]}
                  placeholder="Select"
                  name="staff"
                  Class="custom-class"
                  tabIndex="1"
                  selectedOption={[data1[10]]}
                  disabled={true}
                />
                <InputText
                  title="Locality / Street"
                  type="Place"
                  classStar="text-red-500"
                  name="Place"
                  placeholder="Locality/Street "
                  content={data.LocalityStreet_en}
                  disabled={true}
                />
                <AutoDropDown
                  title="District"
                  classStar="text-red-500"
                  options={[]}
                  placeholder="Select"
                  name="state"
                  Class="custom-class"
                  tabIndex="1"
                  selectedOption={[data1[6]]}
                  disabled={true}
                />
                <AutoDropDown
                  title="Block"
                  classStar="text-red-500"
                  options={[]}
                  placeholder="Select"
                  name="state"
                  Class="custom-class"
                  tabIndex="1"
                  selectedOption={[data1[7]]}
                  disabled={true}
                />
                <AutoDropDown
                  title="City / Village"
                  classStar="text-red-500"
                  options={[]}
                  placeholder="Select"
                  name="state"
                  Class="custom-class"
                  tabIndex="1"
                  selectedOption={[data1[8]]}
                  disabled={true}
                />
              </div>

              <div class={mainTable.labelBold}>List Of Participants</div>
              <div className="hidden md:block overflow-x-auto">
                <div className="table-container w-screen md:w-max xl:w-full max-h-96 ">
                  <table className="w-full border border-gray-300 ">
                    <thead>
                      <tr>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Name
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Age
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Gender
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Mobile No.
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Referral Service
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Referred To
                        </th>
                        <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                          Follow-up
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td className="border border-gray-300 p-2">
                            <input
                              type="text"
                              className={mainTable.input}
                              value={row.participantNameEn}
                              disabled={true}
                              onChange={(e) => {
                                handleInputChange(
                                  e.target,
                                  index,
                                  "participantNameEn"
                                );
                                updateTableData(
                                  e.target.value,
                                  index,
                                  "participantNameEn"
                                );
                              }}
                            />
                          </td>

                          <td className="border border-gray-300 p-2 w-28">
                            <input
                              type="text"
                              className={mainTable.input}
                              value={row.age}
                              disabled={true}
                              onChange={(e) => {
                                handleInputChange(e.target, index, "age");
                                updateTableData(e.target.value, index, "age");
                              }}
                            />
                          </td>
                          <td className="border border-gray-300 p-2">
                            <DropDown
                              options={bindgenderRadioDD}
                              placeholder="Select"
                              name="gender"
                              disabled={true}
                              selectedOption={row.gender}
                              controlFunc={(e) =>
                                updateTableData(e.target.value, index, "gender")
                              }
                            />
                          </td>
                          <td className="border border-gray-300 p-2">
                            <input
                              type="number"
                              disabled={true}
                              className={mainTable.input}
                              value={row.mobileNumber}
                              onChange={(e) => {
                                handleInputChange(
                                  e.target,
                                  index,
                                  "mobileNumber"
                                );
                                updateTableData(
                                  e.target.value,
                                  index,
                                  "mobileNumber"
                                );
                              }}
                            />
                          </td>

                          <td className="border border-gray-300 p-2">
                            <DropDown
                              options={bindreferelserviceDD}
                              placeholder="Select"
                              name="referralService"
                              disabled={true}
                              selectedOption={row.referralService}
                              controlFunc={(e) =>
                                updateTableData(
                                  e.target.value,
                                  index,
                                  "referralService"
                                )
                              }
                            />
                          </td>

                          <td className="border border-gray-300 p-2">
                            <DropDown
                              options={bindreferredtoDD}
                              placeholder="Select"
                              name="referredTo"
                              disabled={true}
                              selectedOption={row.referredTo}
                              controlFunc={(e) =>
                                updateTableData(
                                  e.target.value,
                                  index,
                                  "referredTo"
                                )
                              }
                            />
                          </td>

                          <td className="border border-gray-300 p-2">
                            <input
                              type="date"
                              disabled={true}
                              className={mainTable.input}
                              value={row.fallowUpDate}
                              onChange={(e) => {
                                handleInputChange(
                                  e.target,
                                  index,
                                  "fallowUpDate"
                                );
                                updateTableData(
                                  e.target.value,
                                  index,
                                  "fallowUpDate"
                                );
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className={mainTable.childTableMobile} role="table">
                <div className="w-full md:overflow-y-auto lg:h-96 h-full">
                  {tableData.length > 0 &&
                    tableData.map((row, index) => (
                      <div scope="col" class={mainTable.mobileTable}>
                        {headerData.map((keyData) => (
                          <div
                            scope="cell"
                            class={mainTable.tableData}
                            role="cell"
                          >
                            {keyData.key === "Action" ? (
                              <div class={mainTable.tableData}>
                                <div className="md:block hidden">
                                  <button
                                    id="dropdownMenuIconButton"
                                    data-dropdown-toggle="dropdownDots"
                                    class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50 "
                                    type="button"
                                  >
                                    <svg
                                      class="w-6 h-6"
                                      aria-hidden="true"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                    </svg>
                                  </button>
                                </div>
                                <div className="md:hidden flex justify-center">
                                  <input
                                    type="button"
                                    className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                    value="Add"
                                  />
                                  <input
                                    type="button"
                                    className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                    value="Delete"
                                  />
                                </div>
                              </div>
                            ) : keyData.key === "participantNameEn" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full font-bold">
                                  {keyData.title}
                                </div>
                                <input
                                  type="text"
                                  className={mainTable.input}
                                  value={row.participantNameEn}
                                  disabled={true}
                                  onChange={(e) => {
                                    handleInputChange(
                                      e.target,
                                      index,
                                      "participantNameEn"
                                    );
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "participantNameEn"
                                    );
                                  }}
                                />
                              </div>
                            ) : keyData.key === "age" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full whitespace-nowrap font-bold">
                                  {keyData.title}
                                </div>
                                <input
                                  type="text"
                                  className={mainTable.input}
                                  value={row.age}
                                  disabled={true}
                                  onChange={(e) => {
                                    handleInputChange(e.target, index, "age");
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "age"
                                    );
                                  }}
                                />
                              </div>
                            ) : keyData.key === "gender" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full font-bold">
                                  {keyData.title}
                                </div>
                                <DropDown
                                  options={bindgenderRadioDD}
                                  placeholder="Select"
                                  name="gender"
                                  selectedOption={row.gender}
                                  disabled={true}
                                  controlFunc={(e) =>
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "gender"
                                    )
                                  }
                                />
                              </div>
                            ) : keyData.key === "mobileNumber" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full font-bold">
                                  {keyData.title}
                                </div>
                                <input
                                  type="number"
                                  disabled={true}
                                  className={mainTable.input}
                                  value={row.mobileNumber}
                                  onChange={(e) => {
                                    handleInputChange(
                                      e.target,
                                      index,
                                      "mobileNumber"
                                    );
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "mobileNumber"
                                    );
                                  }}
                                />
                              </div>
                            ) : keyData.key === "referralService" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full whitespace-nowrap font-bold">
                                  {keyData.title}
                                </div>
                                <DropDown
                                  options={bindreferelserviceDD}
                                  placeholder="Select"
                                  name="referralService"
                                  selectedOption={row.referralService}
                                  disabled={true}
                                  controlFunc={(e) =>
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "referralService"
                                    )
                                  }
                                />
                              </div>
                            ) : keyData.key === "referredTo" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full whitespace-nowrap font-bold">
                                  {keyData.title}
                                </div>
                                <DropDown
                                  options={bindreferredtoDD}
                                  placeholder="Select"
                                  name="referredTo"
                                  selectedOption={row.referredTo}
                                  disabled={true}
                                  controlFunc={(e) =>
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "referredTo"
                                    )
                                  }
                                />
                              </div>
                            ) : keyData.key === "fallowUpDate" ? (
                              <div className=" border p-1">
                                <div className="flex items-center w-full font-bold">
                                  {keyData.title}
                                </div>
                                <input
                                  type="date"
                                  disabled={true}
                                  className={mainTable.input}
                                  value={row.fallowUpDate}
                                  onChange={(e) => {
                                    handleInputChange(
                                      e.target,
                                      index,
                                      "fallowUpDate"
                                    );
                                    updateTableData(
                                      e.target.value,
                                      index,
                                      "fallowUpDate"
                                    );
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="flex border p-1">
                                <div className="flex basis-1/2 font-bold">
                                  {keyData.title}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              </div>

              <div className="lg:col-span-3 sm:col-span-1">
                <TextArea
                  inputType="text"
                  title="Description"
                  name="description"
                  rows={4}
                  content={data.Descripition_en}
                  placeholder="Description"
                  disabled={true}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterpersonalContactsPopup;
